import { eEscrowPrepaymentsAtClosing } from '../../../ui-toolkit/enums/eEscrowPrepaymentsAtClosing';
import { generateDefaultViewItem } from '../../../ui-toolkit/cdItems/data/generateDefaultViewItem';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { eReimbursements } from 'ui-toolkit/enums/eReimbursments';
import { eRecordingFees } from '../../../ui-toolkit/enums/eRecordingFees';
import { eNonInterestPrepayments } from '../../../ui-toolkit/enums/eNonInterestPrepayments';
import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';

export const generateDefaultViewItems = (
  ownerId: string,
  loanAmount?: number | null,
  purchasePrice?: number | null
): ICDV3ViewItem[] => {
  const newViewItem = () => ({ ...generateDefaultViewItem(), new: true });
  return [
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.percentage_of_loan_amount,
      removable: false,
      netted_out: true,
      overridden: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.recording_fee,
      sub_type: eRecordingFees.deed,
      removable: false,
      overridden: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.recording_fee,
      sub_type: eRecordingFees.mortgage,
      removable: false,
      overridden: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.non_interest_prepayment,
      sub_type: eNonInterestPrepayments.homeowners_insurance,
      removable: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.non_interest_prepayment,
      sub_type: eNonInterestPrepayments.mortgage_insurance,
      removable: false,
    },
    { ...newViewItem(), owner_id: ownerId, type: eCDV3ItemTypes.interest_prepayment, removable: false },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.non_interest_prepayment,
      sub_type: eNonInterestPrepayments.property_tax,
      removable: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.escrow_at_closing,
      sub_type: eEscrowPrepaymentsAtClosing.homeowners_insurance,
      removable: false,
      netted_out: true,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.escrow_at_closing,
      sub_type: eEscrowPrepaymentsAtClosing.mortgage_insurance,
      removable: false,
      netted_out: true,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.escrow_at_closing,
      sub_type: eEscrowPrepaymentsAtClosing.property_tax,
      removable: false,
      netted_out: true,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.aggregate_adjustment,
      removable: false,
      netted_out: true,
    },
    { ...newViewItem(), owner_id: ownerId, type: eCDV3ItemTypes.lender_credit, removable: false },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.sale_price_of_property,
      removable: false,
      buyer_at_closing: purchasePrice,
    },
    { ...newViewItem(), owner_id: ownerId, type: eCDV3ItemTypes.personal_property_sale, removable: false },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.buyer_reimbursement_to_seller,
      sub_type: eReimbursements.city_and_town_taxes,
      removable: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.buyer_reimbursement_to_seller,
      sub_type: eReimbursements.county_taxes,
      removable: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.buyer_reimbursement_to_seller,
      sub_type: eReimbursements.assessments,
      removable: false,
    },
    { ...newViewItem(), owner_id: ownerId, type: eCDV3ItemTypes.buyer_deposit, removable: false },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.loan_amount,
      removable: false,
      buyer_at_closing: loanAmount,
    },
    { ...newViewItem(), owner_id: ownerId, type: eCDV3ItemTypes.existing_loans_assumed, removable: false },
    { ...newViewItem(), owner_id: ownerId, type: eCDV3ItemTypes.seller_credit, removable: false },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.buyer_reimbursement_from_seller,
      sub_type: eReimbursements.city_and_town_taxes,
      removable: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.buyer_reimbursement_from_seller,
      sub_type: eReimbursements.county_taxes,
      removable: false,
    },
    {
      ...newViewItem(),
      owner_id: ownerId,
      type: eCDV3ItemTypes.buyer_reimbursement_from_seller,
      sub_type: eReimbursements.assessments,
      removable: false,
    },
    { ...newViewItem(), owner_id: ownerId, type: eCDV3ItemTypes.seller_excess_deposit, removable: false },
  ];
};
